import { render, staticRenderFns } from "./NavigationV2.vue?vue&type=template&id=c6013a12"
import script from "./NavigationV2.vue?vue&type=script&lang=js"
export * from "./NavigationV2.vue?vue&type=script&lang=js"
import style0 from "./NavigationV2.vue?vue&type=style&index=0&id=c6013a12&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports